"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateGUID = void 0;
const generateGUID = () => {
    /**
     * Polyfill for random values
     * suitable for SSR (where crypto is not available)
     */
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
exports.generateGUID = generateGUID;
//# sourceMappingURL=generateGUID.js.map